<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="result-table nopads" style="width: 100%; scrollbar-width: none; -ms-overflow-style: none;">
        <vue3-datatable
            ref="resultTable"
            :rows="reports"
            :columns="fields"
            :pagination="false"
            :sticky-header="true"
            :height="reports.length > 7 ? '51em' : '100%'"
            :sortable="true"
            :row-class="getRowClass"
            cell-class="routa-table-cell"
            @row-click="rowClicked"
        >
            <template #icon="data">
                <div v-if="data.value.salt_status >= 0.75">
                      <font-awesome-icon
                          icon="exclamation-circle"
                          :class="{ ban: data.value.salt_status >= 1, defect: data.value.salt_status >= 0.75 }"
                      />
                </div>
            </template>

            <template #form_required="data">
                <div v-if="data.value.form_required" class="col-12 d-flex justify-content-center nopads" style="color: #7FC000">
                    <i class="fa fa-check"></i>
                </div>
            </template>

            <template #salt_status="data">
                {{ data.value.salt_status * 100 }} %
            </template>

        </vue3-datatable>
    </div>
</template>

<script>
import {timeUtils} from '../../mixins/TimeUtils'
import Vue3Datatable from '@bhplugin/vue3-datatable'
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
    name: 'SpreaderRestrictionAreaList',
    components: {FontAwesomeIcon, Vue3Datatable},
    mixins: [timeUtils],
    props: {
        reports: {
            type: Array,
            default: () => ([])
        }
    },
    data() {
        return {
            selectedRowId: null,
            loading: 0,
        }
    },
    computed: {
        fields() {
                return [
                    {
                        field: 'icon',
                        title: '',
                        sort: false,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'id',
                        title: this.$t('common.id'),
                        sort: false,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'contract',
                        title: this.$t('orders.contract'),
                        sort: true,
                        minWidth: '15em',
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'valid_year',
                        title: this.$t('spreader_data.contract_year'),
                        sort: true,
                        type: 'number',
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'road_num',
                        title: this.$t('map.road_number'),
                        sort: true,
                        type: 'number',
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'start_sec',
                        title: this.$t('map.road_section_start'),
                        sort: true,
                        type: 'number',
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'start_dist',
                        title: this.$t('map.distance_start'),
                        sort: true,
                        type: 'number',
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'end_sec',
                        title: this.$t('map.road_section_end'),
                        sort: true,
                        type: 'number',
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'end_dist',
                        title: this.$t('map.distance_end'),
                        sort: true,
                        type: 'number',
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'form_required',
                        title: this.$t('spreader_data.formate_required'),
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'max_salt_amount',
                        title: this.$t('spreader_data.max_salt_amount'),
                        sort: true,
                        type: 'number',
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'total_salt_amount',
                        title: this.$t('spreader_data.total_salt_amount'),
                        sort: true,
                        type: 'number',
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'total_formate_amount',
                        title: this.$t('spreader_data.total_formate_amount'),
                        sort: true,
                        type: 'number',
                        headerClass: 'routa-table-header'
                    }
                ]
        },

    },
    methods: {

        rowClicked(item) {
            this.$emit('rowClicked', item)
            this.selectedRowId = item ? item.id : null
        },

        getRowClass(row) {
            return row.id === this.selectedRowId ? 'routa-table-row selected-row row-id-' + row.id : 'routa-table-row  row-id-' + row.id
        },

        setSelection(index) {
            this.selectedRowId = null
            if (index >= 0 && index < this.reports.length) {
                this.selectedRowId = this.reports[index].id
            }
        },

        resetSelection() {
            this.selectedRowId = null
        },

        scrollToRow(index) {
            this.$nextTick(() => {
                if (index >= 0 && index < this.reports.length) {
                    const targetId = this.reports[index].id
                    const rowElement = document.querySelector(`.row-id-${targetId}`)
                    if (rowElement) {
                        rowElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
                    }
                }
            })
        }
    }
}
</script>
<style>
</style>
